import { scrubSensitiveData } from '@/app/sentryScrub';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

export function initSentry(): void {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_STAGE || 'local',
    release: import.meta.env.VITE_APP_VERSION,
    sendDefaultPii: false,
    beforeSend: scrubSensitiveData,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.05 : 1,
    tracePropagationTargets: ['localhost', /^\/api\//],
    profileSessionSampleRate: import.meta.env.PROD ? 0.05 : 1,
  });
}
